/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class RestoreSnapshot {
    static readonly type = '[Snapshot] Restore previous snapshot';

    constructor(public payload: {group: string}) {}
}

export class ClearSnapshots {
    static readonly type = '[Snapshot] Clear snapshots';

    constructor(public payload: {group: string}) {}
}

